import { Flex, Box, Text, HStack, Divider } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { CalenderIcon } from "@root/assets/icons/calenderIcon";

interface Activity {
  title: string;
  description: string;
  date: string;
  value: string;
}

const ActivityCard: React.FC<Activity> = ({
  title,
  description,
  date,
  value,
}) => {
  return (
    <Box
      border="1px solid #E0E0E0"
      borderRadius="12px"
      p="16px"
      bg="white"
      display="flex"
      flexDirection="column"
      gap="8px"
    >
      <Text fontSize="18px" fontWeight="400" color="#010610">
        {title}
      </Text>

      <Text fontSize="18px" fontWeight="400" color="#5C6670">
        {description}
      </Text>

      <HStack spacing="8px" color="#5C6670" fontSize="18px" fontWeight="500">
        <CalenderIcon />
        <Text fontSize="18px" fontWeight="500" color="#5C6670">
          {date}
        </Text>
        <Box as="span" w="1" h="1" borderRadius="full" bg="#5C6670" />
        <Text>{value}</Text>
      </HStack>
    </Box>
  );
};

const RecentActivity: React.FC = () => {
  const { t } = useTranslation("common");

  // Example mock data
  const activities: Activity[] = [
    {
      title: "System Update",
      description: "New patch applied successfully.",
      date: "2025-10-02",
      value: "4:22",
    },
    {
      title: "User Login",
      description: "John Doe logged into the dashboard.",
      date: "2025-10-01",
      value: "15:45",
    },
    {
      title: "Risk Alert",
      description: "High risk detected in Project Alpha.",
      date: "2025-09-30",
      value: "9:30",
    },
  ];

  return (
    <Flex
      flexDirection="column"
      border="1px solid #E0E0E0"
      borderRadius="16px"
      p="24px"
      gap={4}
    >
      <Text fontSize="24px" fontWeight="bold" color="black">
        {t("recentActivity.title")}
      </Text>

      <Flex flexDirection="column" gap={4}>
        {activities?.map((a, idx) => (
          <ActivityCard key={idx} {...a} />
        ))}
      </Flex>
    </Flex>
  );
};

export default RecentActivity;
